import { render } from "./StatsSection.vue?vue&type=template&id=51f105f9&scoped=true"
const script = {}

import "./StatsSection.vue?vue&type=style&index=0&id=51f105f9&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51f105f9"]])

export default __exports__